<template>
	<!-- Dialogo para indicar errores -->
  <v-dialog
    v-model="dialogGrupos.estatus"
    persistent
    max-width="1800"
  >
		<v-card>
      <v-card-title>
        <span class="text-subtitle-1 font-weight-bold text-center">
          Busqueda de grupos
        </span>
        
        <v-spacer></v-spacer>

        <v-tooltip bottom color="blue" max-width="300">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-2 mb-2"
              small dark color="green"
              @click="exportarInscripciones()"
              tile
              v-bind="attrs"
              v-on="on"
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>
          </template>
          <span>Descargar los grupos en formato Excel</span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-select
                  :items="planteles"
                  v-model="plantel"
                  label="Plantel"
                  filled
                  dense
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-select>
              </template>
              <span>Filtra los grupos por plantel</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-select
                  :items="niveles"
                  v-model="nivel"
                  label="Nivel"
                  filled
                  dense
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-select>
              </template>
              <span>Filtra los grupos por nivel</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-select
                  :items="horarios"
                  v-model="horario"
                  label="Horario"
                  filled
                  dense
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-select>
              </template>
              <span>Filtra los grupos por horario</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" sm="6" md="4" lg="4" class="pb-0">
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-autocomplete
                  :items="ciclos"
                  v-model="ciclo"
                  label="Ciclo"
                  filled
                  dense
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-autocomplete>
              </template>
              <span>Filtra los grupos por ciclo escolar</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12"  md="8" lg="8" class="pb-0">
            <v-tooltip bottom color="blue" max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="search"
                  label="Buscar"
                  filled
                  append-icon="mdi-magnify"
                  dense
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <span>Buscar grupos por nombre, horario u otros datos</span>
            </v-tooltip>
          </v-col>


        </v-row>

        <v-data-table
			    :headers="headers"
			    :items="filterGrupos"
			    class="elevation-0"
			    :search="search"
			    :mobile-breakpoint="100"
          dense
			  >

          <template v-slot:item.meta="props" >
            <v-edit-dialog
              :return-value.sync="props.item.meta"
              @save="guardarMeta( props.item )"
              large
              v-if="['NIVEL 1','NIVEL 2','NIVEL 3'].includes( props.item.nivel ) && [334,568,28].includes( getdatosUsuarioERPERP.iderp )"
            >
              {{ props.item.meta }}
              <template v-slot:input>
                <v-text-field
                  v-model="props.item.meta"
                  label="Meta"
                  type="number"
                  single-line
                ></v-text-field>
              </template>
            </v-edit-dialog>

            <span v-if="![334,568,28].includes( getdatosUsuarioERPERP.iderp )">{{ props.item.meta }}</span>
          </template>

          <template v-slot:item.salon="props">
            <div>
              <!-- Si cumple la condición, mostramos el edit-dialog -->
              <v-edit-dialog
                v-if="( [568,334].includes( getdatosUsuarioERPERP.iderp ) && !props.item.grupo.match('ONLINE') )||
                      ( getdatosUsuarioERPERP.idpuesto === 18 &&
                        getdatosUsuarioERPERP.id_plantel === props.item.id_plantel &&
                        props.item.grupo.match('CICLO 09_25') && !props.item.grupo.match('ONLINE') )"
                :return-value.sync="props.item.id_salon"
                @save="guardarSalon(props.item, props.item.id_salon)"
                large
                save-text="Guardar"
                cancel-text="Cancelar"
              >
                {{ props.item.salon }}

                <template v-slot:input>
                  <v-autocomplete
                    v-model="props.item.id_salon"
                    :items="salones.filter(s => s.id_plantel === props.item.id_plantel)"
                    item-text="salon"
                    item-value="id_salon"
                    label="Selecciona salón"
                    style="margin-top: 2rem;"
                    dense
                    clearable
                  />
                </template>
              </v-edit-dialog>

              <!-- Si no cumple, mostramos solo el texto sin posibilidad de editar -->
              <span v-else>
                {{ props.item.salon }}
              </span>
            </div>
          </template>

          <template v-slot:item.validado="props">
            <!-- {{ && getdatosUsuarioERPERP.id_plantel === props.item.id_plantel }} -->
            <div v-if="!props.item.nombre_completo_aprobador">
              <!-- Si no hay validador, mostrar botón -->
              <v-btn
              v-if="getdatosUsuarioERPERP.iderp === 568 ||
              ( getdatosUsuarioERPERP.idpuesto === 18 && getdatosUsuarioERPERP.id_plantel === props.item.id_plantel && props.item.grupo.match('CICLO 09_25') )"
              small color="primary" @click="abrirModalValidar(props.item)">
                Pendiente
              </v-btn>
            </div>
            <div v-else>
              <!-- Si ya está validado, mostrar check o tacha -->
              <v-icon v-if="props.item.validado">mdi-check-circle</v-icon>
              <v-icon v-else>mdi-close-circle</v-icon>
            </div>
          </template>

          <template v-slot:item.comentarios="{ item }">
            <div
              small color="primary" @click="[568,334].includes( getdatosUsuarioERPERP.iderp ) ? abrirModalComentarios(item) : ''">
              {{ item.comentarios }}
            </div>
            <v-btn v-if="!item.comentarios && [568,334].includes( getdatosUsuarioERPERP.iderp ) " color="success" @click="[568,334].includes( getdatosUsuarioERPERP.iderp ) ? abrirModalComentarios(item) : ''">Add comentario</v-btn>
          </template>

			    <template v-slot:no-data>
			      <v-btn
			        color="primary"
			        @click="initialize"
			        small
			      >
			        Actualizar
			      </v-btn>
			    </template>

			  </v-data-table>
      </v-card-text>

      <v-card-actions>
        <v-btn
          color="black"
          dark
          small
          tile
          @click="dialogGrupos.estatus = false"
        >
        	<v-icon small left>mdi-cancel</v-icon>
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>

	  <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

    <v-dialog v-model="modalValidar" max-width="500px">
      <v-card>
        <v-card-title>Validar Grupo</v-card-title>
        <v-card-text>
          <v-radio-group v-model="validacionSeleccionada">
            <v-radio label="Aprobado" :value="true"></v-radio>
            <v-radio label="No aprobado" :value="false"></v-radio>
          </v-radio-group>
          <v-textarea
            v-model="motivoValidacion"
            label="Motivo"
            rows="3"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="modalValidar = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="guardarValidacion()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalComentarios" max-width="500px">
      <v-card>
        <v-card-title>Comentarios</v-card-title>
        <v-card-text>
          <v-textarea
            v-model="comentarios"
            label="Motivo"
            rows="3"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="modalComentarios = false">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="guardarComentarios()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-dialog>


  

</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta              from '@/components/alertas/Alerta.vue'
  import carga               from '@/components/alertas/carga.vue';

  import validarErrores      from '@/mixins/validarErrores'

  import mixinLeads          from '@/mixins/mixinLeads'
  import funcionesExcel      from '@/mixins/funcionesExcel'

	// Componentes
  export default {
  	components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, mixinLeads, funcionesExcel ],

    
  	props:['dialogGrupos'],

    
    data: () => ({
			// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

    	// Datos del alumno inscrito
    	grupos:[],

    	planteles: [],
    	plantel  : null,
    	niveles  : [],
    	nivel    : null,
    	ciclos   : [],
    	ciclo    : null,
    	horarios : [],
    	horario  : null,
      salones  : [],

    	// tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      grupos: [],
      headers: [
        { text: 'ID'          , value: 'id_grupo'                   },
        { text: 'Grupo'       , value: 'grupo'                      },
        { text: 'Horario'     , value: 'horario'                    },
        { text: 'Cupo'        , value: 'capacidad'                  },
        { text: 'Nivel'       , value: 'nivel'                      },
        { text: 'Inscritos'   , value: 'inscritos'                  },
        { text: 'Meta'        , value: 'meta'                       },
        { text: 'Grupo Ant'   , value: 'grupo_ant'                  },
        { text: 'Insc. Ant'   , value: 'inscritos_ant'              },
        { text: 'Grupo Sig.'  , value: 'grupo_consecutivo'          },
        { text: 'Disponibles' , value: 'disponibles'                },
        { text: 'Id Plantel'  , value: 'id_plantel'                },
        { text: 'Id Salon'    , value: 'id_salon'                },
        { text: 'Salon'       , value: 'salon'                },
        { text: 'Validado'    , value: 'validado'                   },
        { text: 'Aprobaor'    , value: 'nombre_completo_aprobador'  },
        { text: 'Motivo'      , value: 'motivo'                     },
        { text: 'Comentarios'      , value: 'comentarios'                     },
      ],

      modalValidar: false,
      grupoSeleccionado: {},
      validacionSeleccionada: null,
      motivoValidacion: '',

      comentarios:'',
      modalComentarios: false,
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP', 'getEscuela']),

    	filterGrupos(){

    		let grupoFinales = this.grupos

    		// Validamos si hay un plantel y filtramos por ese plantel
    		if( this.plantel ){ grupoFinales = grupoFinales.filter( el => { return el.plantel == this.plantel } )}

    		// Validamos si hay un horario y filtramos por ese horario
    		if( this.horario ){ grupoFinales = grupoFinales.filter( el => { return el.horario == this.horario } )}

    		// Validamos si hay un ciclo y filtramos por ese ciclo
    		if( this.ciclo ){ grupoFinales = grupoFinales.filter( el => { return el.ciclo == this.ciclo } )}

    		// Validamos si hay un nivel y filtramos por ese nivel
    		if( this.nivel ){ grupoFinales = grupoFinales.filter( el => { return el.nivel == this.nivel } )}

        return grupoFinales
      },
    },

    watch: {

      ciclo( val ){

        console.log( val )

      }

    },

    async created () {
      await this.initialize()
    },


    methods: {

      // Obtener todas las sucursales
      initialize() {

        this.cargar  = true
        this.grupos  = []

        let ruta = 'grupos.habiles/' + this.getEscuela
        if( this.getdatosUsuarioERPERP.iderp == 7 ){
          ruta =  'grupos.habiles/'
        }

        return this.$http.get( ruta ).then((response) => {

          // Llenamos la etapa incial
          this.grupos    = response.data.grupos

          // if( )

          this.planteles = response.data.planteles
          this.niveles   = response.data.niveles.filter( el => el )
          this.ciclos    = response.data.ciclos
          this.horarios  = response.data.horarios
          this.salones   = response.data.salones
          this.cargar    = false

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      exportarInscripciones( ){

        let ciclo = this.ciclo.substring(0,11)

        let grupos = this.grupos.filter( el => el.grupo.match(ciclo) )

        this.exportExcel( grupos, 'Grupos')

      },

      guardarMeta( meta ){
        this.cargar  = true

        return this.$http.post('grupos.add.meta', meta ).then((response) => {

          // Llenamos la etapa incial
          this.initialize( )

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      habilitarCambio( item ){
        if( ['NIVEL 1','NIVEL 2','NIVEL 3'].includes( item.nivel ) ){
          console.log( item.nivel )
          true
        }else{
          false
        }
      },

      abrirModalValidar(item) {

        this.grupoSeleccionado.id_usuario_aprobador = this.getdatosUsuarioERPERP.id_usuario
        this.grupoSeleccionado.id_grupo = item.id_grupo;
        this.validacionSeleccionada = 0;
        this.motivoValidacion = '';
        this.modalValidar = true;
      },

      abrirModalComentarios(item) {

        this.grupoSeleccionado.id_grupo = item.id_grupo;
        this.comentarios = '';
        this.modalComentarios = true;
      },

      guardarValidacion() {

        if (!this.grupoSeleccionado && getdatosUsuarioERPERP.idpuesto != 18) return;

        // Actualizar tabla localmente
        this.grupoSeleccionado.validado = this.validacionSeleccionada ? 1 : 0;
        this.grupoSeleccionado.motivo = this.motivoValidacion;

        // Aquí iría tu llamada al backend
        this.$http.post('grupos.update.validacion', this.grupoSeleccionado)
        .finally( () => {
          this.initialize()
        })

        this.modalValidar = false;
      },

      guardarComentarios() {

        // Actualizar tabla localmente
        this.grupoSeleccionado.comentarios = this.comentarios;

        // Aquí iría tu llamada al backend
        this.$http.post('grupos.update.comentarios', this.grupoSeleccionado)
        .finally( () => {
          this.initialize()
        })

        this.modalComentarios = false;
      },

      guardarSalon(grupo, id_salon){

        const id_grupo = grupo.id_grupo

        this.$http.post('grupos.update.salon', { id_grupo, id_salon })
        .finally( () => {
          this.initialize()
        })

      }

    },
  };
</script>
